define('widgets/form_text_field/viewmodel',['require'],function (require) {
    
    var Widget = function () {
    };

    Widget.prototype.activate = function (settings) {
        var self = this;

        self.field = settings.field;
        self.hasFocus = ko.observable(false);
        self.hasBeenUpdated = ko.observable(false);

        var dirtyFlag = new ko.DirtyFlag([self.field.value]);
        self.isDirty = ko.computed(function () {
            return dirtyFlag().isDirty();
        });

        self.showUpdatedIndicator = ko.computed(function () {
            return !self.hasFocus() && !self.isDirty() && self.hasBeenUpdated();
        });

        self.field.editable.subscribe(function (newValue) {
            self.hasBeenUpdated(false); // reset
        });
        self.field.editLayout = ko.observable(false);
        self.field.editLayout.focus = function () { };
        self.field.editLayout.isFocus = ko.observable(false);
        self.field.editLayout.editList = function () { };

        self.update = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && self.field.editable();
            },
            execute: function (data, event, complete) {
                self.hasFocus(false);
                if (self.isValid()) {
                    settings
                    .update(self.field)
                    .done(function () {
                        self.hasBeenUpdated(true);
                        dirtyFlag().reset();
                        complete();
                    })
                    .fail(function () {
                        complete();
                    });
                } else {
                    self.errors.showAllMessages();
                    complete();
                }
            }
        });

        self.errors = ko.validation.group(self.field);
        self.isValid = ko.computed(function () {
            return self.errors().length == 0;
        });
    };

    Widget.prototype.attached = function (viewHtml) {
        var self = this;

        $("input.controls-is-visible:checkbox", viewHtml).change(function () {
            self.field.visible(this.checked);
        });

        var $textareas = $('textarea', viewHtml);

        // set init (default) state   
        $textareas.data('x', $textareas.outerWidth());
        $textareas.data('y', $textareas.outerHeight());

        $textareas.mouseup(function () {

            var $this = $(this);

            if ($this.outerWidth() != $this.data('x') || $this.outerHeight() != $this.data('y')) {
                console.warn($this.outerWidth() + ' - ' + $this.data('x') + '\n' + $this.outerHeight() + ' - ' + $this.data('y'));
            }

            // set new height/width
            $this.data('x', $this.outerWidth());
            $this.data('y', $this.outerHeight());
        });

        //$("textarea").resizable({
        //    rows: 4,
        //    resize: function() {
        //        console.warn(this);
        //        //$("input[type=checkbox].controls-is-visible")
        //    }
        //});
    };

    return Widget;
});
